'use strict';

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var decoder = require('./decoder.js');

var CarIteratorBase = /*#__PURE__*/function () {
  function CarIteratorBase(version, roots, iterable) {
    _classCallCheck(this, CarIteratorBase);

    this._version = version;
    this._roots = roots;
    this._iterable = iterable;
    this._decoded = false;
  }

  _createClass(CarIteratorBase, [{
    key: "version",
    get: function get() {
      return this._version;
    }
  }, {
    key: "getRoots",
    value: function () {
      var _getRoots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._roots);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRoots() {
        return _getRoots.apply(this, arguments);
      }

      return getRoots;
    }()
  }]);

  return CarIteratorBase;
}();

var CarBlockIterator = /*#__PURE__*/function (_CarIteratorBase, _Symbol$asyncIterator) {
  _inherits(CarBlockIterator, _CarIteratorBase);

  var _super = _createSuper(CarBlockIterator);

  function CarBlockIterator() {
    _classCallCheck(this, CarBlockIterator);

    return _super.apply(this, arguments);
  }

  _createClass(CarBlockIterator, [{
    key: _Symbol$asyncIterator,
    value: function value() {
      if (this._decoded) {
        throw new Error('Cannot decode more than once');
      }

      if (!this._iterable) {
        throw new Error('Block iterable not found');
      }

      this._decoded = true;
      return this._iterable[Symbol.asyncIterator]();
    }
  }], [{
    key: "fromBytes",
    value: function () {
      var _fromBytes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(bytes) {
        var _yield$_fromBytes, version, roots, iterator;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _fromBytes(bytes);

              case 2:
                _yield$_fromBytes = _context2.sent;
                version = _yield$_fromBytes.version;
                roots = _yield$_fromBytes.roots;
                iterator = _yield$_fromBytes.iterator;
                return _context2.abrupt("return", new CarBlockIterator(version, roots, iterator));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fromBytes(_x) {
        return _fromBytes2.apply(this, arguments);
      }

      return fromBytes;
    }()
  }, {
    key: "fromIterable",
    value: function () {
      var _fromIterable2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(asyncIterable) {
        var _yield$_fromIterable, version, roots, iterator;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _fromIterable(asyncIterable);

              case 2:
                _yield$_fromIterable = _context3.sent;
                version = _yield$_fromIterable.version;
                roots = _yield$_fromIterable.roots;
                iterator = _yield$_fromIterable.iterator;
                return _context3.abrupt("return", new CarBlockIterator(version, roots, iterator));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fromIterable(_x2) {
        return _fromIterable2.apply(this, arguments);
      }

      return fromIterable;
    }()
  }]);

  return CarBlockIterator;
}(CarIteratorBase, Symbol.asyncIterator);

var CarCIDIterator = /*#__PURE__*/function (_CarIteratorBase2, _Symbol$asyncIterator2) {
  _inherits(CarCIDIterator, _CarIteratorBase2);

  var _super2 = _createSuper(CarCIDIterator);

  function CarCIDIterator() {
    _classCallCheck(this, CarCIDIterator);

    return _super2.apply(this, arguments);
  }

  _createClass(CarCIDIterator, [{
    key: _Symbol$asyncIterator2,
    value: function value() {
      if (this._decoded) {
        throw new Error('Cannot decode more than once');
      }

      if (!this._iterable) {
        throw new Error('Block iterable not found');
      }

      this._decoded = true;

      var iterable = this._iterable[Symbol.asyncIterator]();

      return {
        next: function next() {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var next;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return iterable.next();

                  case 2:
                    next = _context4.sent;

                    if (!next.done) {
                      _context4.next = 5;
                      break;
                    }

                    return _context4.abrupt("return", next);

                  case 5:
                    return _context4.abrupt("return", {
                      done: false,
                      value: next.value.cid
                    });

                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }))();
        }
      };
    }
  }], [{
    key: "fromBytes",
    value: function () {
      var _fromBytes3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(bytes) {
        var _yield$_fromBytes2, version, roots, iterator;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _fromBytes(bytes);

              case 2:
                _yield$_fromBytes2 = _context5.sent;
                version = _yield$_fromBytes2.version;
                roots = _yield$_fromBytes2.roots;
                iterator = _yield$_fromBytes2.iterator;
                return _context5.abrupt("return", new CarCIDIterator(version, roots, iterator));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function fromBytes(_x3) {
        return _fromBytes3.apply(this, arguments);
      }

      return fromBytes;
    }()
  }, {
    key: "fromIterable",
    value: function () {
      var _fromIterable3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(asyncIterable) {
        var _yield$_fromIterable2, version, roots, iterator;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _fromIterable(asyncIterable);

              case 2:
                _yield$_fromIterable2 = _context6.sent;
                version = _yield$_fromIterable2.version;
                roots = _yield$_fromIterable2.roots;
                iterator = _yield$_fromIterable2.iterator;
                return _context6.abrupt("return", new CarCIDIterator(version, roots, iterator));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function fromIterable(_x4) {
        return _fromIterable3.apply(this, arguments);
      }

      return fromIterable;
    }()
  }]);

  return CarCIDIterator;
}(CarIteratorBase, Symbol.asyncIterator);

function _fromBytes(_x5) {
  return _fromBytes4.apply(this, arguments);
}

function _fromBytes4() {
  _fromBytes4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(bytes) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (bytes instanceof Uint8Array) {
              _context7.next = 2;
              break;
            }

            throw new TypeError('fromBytes() requires a Uint8Array');

          case 2:
            return _context7.abrupt("return", decodeIterator(decoder.bytesReader(bytes)));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fromBytes4.apply(this, arguments);
}

function _fromIterable(_x6) {
  return _fromIterable4.apply(this, arguments);
}

function _fromIterable4() {
  _fromIterable4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(asyncIterable) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(!asyncIterable || !(typeof asyncIterable[Symbol.asyncIterator] === 'function'))) {
              _context8.next = 2;
              break;
            }

            throw new TypeError('fromIterable() requires an async iterable');

          case 2:
            return _context8.abrupt("return", decodeIterator(decoder.asyncIterableReader(asyncIterable)));

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fromIterable4.apply(this, arguments);
}

function decodeIterator(_x7) {
  return _decodeIterator.apply(this, arguments);
}

function _decodeIterator() {
  _decodeIterator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(reader) {
    var decoder$1, _yield$decoder$1$head, version, roots;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            decoder$1 = decoder.createDecoder(reader);
            _context9.next = 3;
            return decoder$1.header();

          case 3:
            _yield$decoder$1$head = _context9.sent;
            version = _yield$decoder$1$head.version;
            roots = _yield$decoder$1$head.roots;
            return _context9.abrupt("return", {
              version: version,
              roots: roots,
              iterator: decoder$1.blocks()
            });

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _decodeIterator.apply(this, arguments);
}

exports.CarBlockIterator = CarBlockIterator;
exports.CarCIDIterator = CarCIDIterator;
exports.CarIteratorBase = CarIteratorBase;